import React from 'react';
import PropTypes from 'prop-types';
import useHideNavigation from 'shell/hooks/useHideNavigation';
import { IconButton } from '@material-ui/core';
import { CloseIcon } from 'sharedComponents/Icons';

const Video = React.lazy(() => import('modules/clienteling/components/Video'));

const SearchScanner = ({ classes, onClose, onCodeDetected }) => {
  useHideNavigation();

  const onScanCompleted = (value) => {
    onCodeDetected(value);
    onClose();
  };

  return (
    <div className={classes.root}>
      <IconButton onClick={onClose} className={classes.closeBtn} data-testid="close-search-scanner-btn">
        <CloseIcon />
      </IconButton>
      <React.Suspense fallback={<div>Loading...</div>}>
        <Video callback={onScanCompleted} />
      </React.Suspense>
    </div>
  );
};

SearchScanner.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  onClose: PropTypes.func,
  onCodeDetected: PropTypes.func,
};

SearchScanner.defaultProps = {
  classes: {},
  onClose: () => {},
  onCodeDetected: () => {},
};

export default SearchScanner;
